import { render, staticRenderFns } from "./AppGroupDocumentItem.vue?vue&type=template&id=4175819e&scoped=true&"
import script from "./AppGroupDocumentItem.vue?vue&type=script&lang=js&"
export * from "./AppGroupDocumentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175819e",
  null
  
)

export default component.exports